module.exports = __webpack_public_path__ + "static/mahathi-feec3ebb139cca15e9232ca6550e38b9.jpg";